// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-folder{
    cursor: pointer;
    color: #4461F2;
}

.add-folder:hover{
    color: #448af2;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/file.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".add-folder{\r\n    cursor: pointer;\r\n    color: #4461F2;\r\n}\r\n\r\n.add-folder:hover{\r\n    color: #448af2;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
